// extracted by mini-css-extract-plugin
var _1 = "ProviderSearchItem-moduleProviderSearchItem__K_kaQ SearchItem-moduleSearchItem__qpbuZ";
export { _1 as "ProviderSearchItem" }
